import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "ReferralSource/";

const getReferralSourceById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetReferralSourceById?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getReferralSources = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetReferralSources', constants.REQUIRE_INTERCEPTORS);

const saveReferralSource = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveReferralSource', model, constants.REQUIRE_INTERCEPTORS);

const deleteReferralSource = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteReferralSource?id=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getReferralSourceById,
    getReferralSources,
    saveReferralSource,
    deleteReferralSource
}